import React from 'react'

import type { ValueBannerContentBlock } from '@library/api-menu-experience'
import { ValueBanner } from '@library/menu-page'

type ValueBannerContentBlockWrapperProps = {
  contentBlock: ValueBannerContentBlock
}

export const ValueBannerContentBlockWrapper = ({
  contentBlock,
}: ValueBannerContentBlockWrapperProps) => <ValueBanner contentBlock={contentBlock} />
